import type { ReactNode } from "react";
import { useTranslations } from "@/hooks/useTranslations";
import { ShieldPersonRegular } from "@fluentui/react-icons";
import styles from "./PartnerCourtesyPage.module.scss";

export function PartnerCourtesyPage(): ReactNode {
  const { t } = useTranslations();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <ShieldPersonRegular className={styles.icon} aria-hidden="true" />
        
        <h1 className={styles.title}>
          {t("partnerCourtesyPage.title")}
        </h1>

        <p className={styles.message}>
          {t("partnerCourtesyPage.message")}
        </p>

        <div className={styles.infoSection}>
          <h2 className={styles.infoTitle}>
            {t("partnerCourtesyPage.whatIsPartnerTitle")}
          </h2>
          <p className={styles.infoText}>
            {t("partnerCourtesyPage.whatIsPartnerText")}
          </p>
        </div>

        <div className={styles.actionSection}>
          <p className={styles.actionText}>
            {t("partnerCourtesyPage.needHelpText")}
          </p>
          <a 
            href="https://partner.microsoft.com/support" 
            className={styles.contactLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t("partnerCourtesyPage.contactSupportAriaLabel")}
          >
            {t("partnerCourtesyPage.contactSupport")}
          </a>
        </div>
      </div>
    </div>
  );
}